export const EMOJI_CATEGORIES = {
  PROFESSIONAL: {
    name: "Professional & Business",
    emojis: ["💼", "📊", "📈", "🎯", "🏆", "💰", "📱", "💻", "🔔", "📝"],
  },
  CELEBRATION: {
    name: "Celebration",
    emojis: ["🎉", "🎊", "🌟", "✨", "⭐", "🏅", "🎁", "🎈"],
  },
  ENGAGEMENT: {
    name: "Engagement",
    emojis: ["👍", "❤️", "💯", "🔥", "👏", "🙌", "✅", "💪"],
  },
  COMMUNICATION: {
    name: "Communication",
    emojis: ["💬", "💡", "🤔", "💭", "📢", "🗣️", "👀", "📣"],
  },
  EMOJI: {
    name: "Smileys",
    emojis: ["😊", "🚀", "🌍", "🌈", "⚡", "🎓"],
  },
};
